import React, { useMemo } from 'react';

/**
 * SectionCompania - Componente modular para la selección de Compañía Aseguradora,
 * Organizador y PAS. Optimizado con filtros locales en memoria y diseño unificado.
 */
const SectionCompania = ({ state, actions }) => {
    // Extraemos los datos necesarios del estado global
    const { formData, dbMasters, companiaLists } = state;
    const { handleChange, handleCompaniaChange } = actions;

    // --- FILTRADO Y ORDENAMIENTO DE COMPAÑÍAS DEL RAMO PATRIMONIAL ---
    const sortedCompanias = useMemo(() => {
        return [...(dbMasters?.companias || [])]
            .filter(c => c.grupo === 'PATRIMONIALES')
            .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || ''));
    }, [dbMasters?.companias]);

    return (
        <fieldset className="border border-gray-200 rounded-xl p-6 bg-white shadow-sm text-left transition-all duration-300">
            <legend className="px-3 text-lg font-bold text-gray-700 tracking-tight">Datos de la Compañía</legend>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-2">
                
                {/* 1. SELECCIÓN DE COMPAÑÍA */}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">Compañía *</label>
                    <select 
                        name="compania" 
                        value={formData.compania || ''} 
                        onChange={(e) => handleCompaniaChange(e.target.value)} 
                        className="input-round font-bold border-slate-200 focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all duration-200" 
                        required
                    >
                        <option value="">Seleccione...</option>
                        {sortedCompanias.map(c => (
                            <option key={c.id} value={c.nombre}>
                                {c.nombre}
                            </option>
                        ))}
                    </select>
                </div>

                {/* 2. CÓDIGO ORGANIZADOR (DEPENDIENTE) */}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">Orga *</label>
                    <select 
                        name="organizador" 
                        value={formData.organizador || ''} 
                        onChange={handleChange} 
                        className={`input-round border-slate-200 focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all duration-200 ${
                            (!companiaLists?.organizadores || companiaLists.organizadores.length === 0) 
                                ? 'bg-slate-50 opacity-60 cursor-not-allowed' 
                                : 'bg-white'
                        }`} 
                        disabled={!companiaLists?.organizadores || companiaLists.organizadores.length === 0}
                        required
                    >
                        <option value="">
                            {!companiaLists?.organizadores || companiaLists.organizadores.length === 0 
                                ? 'Sin códigos...' 
                                : 'Seleccione...'}
                        </option>
                        {(companiaLists?.organizadores || []).map((o, idx) => (
                            <option key={idx} value={o}>{o}</option>
                        ))}
                    </select>
                </div>

                {/* 3. CÓDIGO PAS (DEPENDIENTE) */}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">PAS *</label>
                    <select 
                        name="pas" 
                        value={formData.pas || ''} 
                        onChange={handleChange} 
                        className={`input-round border-slate-200 focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all duration-200 ${
                            (!companiaLists?.productores || companiaLists.productores.length === 0) 
                                ? 'bg-slate-50 opacity-60 cursor-not-allowed' 
                                : 'bg-white'
                        }`} 
                        disabled={!companiaLists?.productores || companiaLists.productores.length === 0}
                        required
                    >
                        <option value="">
                            {!companiaLists?.productores || companiaLists.productores.length === 0 
                                ? 'Sin códigos...' 
                                : 'Seleccione...'}
                        </option>
                        {(companiaLists?.productores || []).map((p, idx) => (
                            <option key={idx} value={p}>{p}</option>
                        ))}
                    </select>
                </div>
            </div>
        </fieldset>
    );
};

export default SectionCompania;